<!-- 
  <template>
    <v-navigation-drawer
      v-model="drawer"
      location="bottom"
      :width="100"
      class="d-flex"
      disable-resize-watcher
      hide-overlay
      app
    >
      <p v-if="lang == 'en'">
          This website uses cookies to give you the best possible user experience. By continuing to use the website without changing your browser settings you agree to the use of cookies. For further information on cookies, please read our        
          <a href="#" @click.prevent="$router.push('/privacyPolicy')"> privacy policy.</a> 
      </p>
      <p v-if="lang == 'ru'">
          Этот сайт использует файлы cookie, чтобы обеспечить вам максимально возможное удобство пользования. Продолжая использовать сайт без изменения настроек браузера, вы соглашаетесь на использование файлов cookie. Для получения дополнительной информации о файлах cookie, пожалуйста, ознакомьтесь с нашей        
          <a href="#" @click.prevent="$router.push('/privacyPolicy')"> политика обработки персональных данных.</a> 
      </p>
      <v-btn @click="acceptCookie()"><span v-if="lang == 'en'">Agree</span><span v-if="lang == 'ru'">Согласие</span></v-btn>
    </v-navigation-drawer>
  </template>
  
  <script>
  import "./CoockieWindow.scss";
  import { mapState } from "vuex";
  export default {    
    name: "CoockieWindow",
    data() {
        return {
            drawer: true,
        }
    },
    created() {
      console.log(this.getAcceptValue());
      const acceptValue = this.getAcceptValue()
      if (acceptValue === 'yes') {
        this.drawer = false
      }
    },
    computed: {
      ...mapState(['lang']),
    },
    methods: {
      acceptCookie() {
        document.cookie = "accept=yes;"
        // this.$cookie.set("accept","yes",10)
        this.drawer = false
        console.log(document.cookie);
      },
      getAcceptValue() {
        const cookies = document.cookie.split('; ');
        
        for (let cookie of cookies) {
            const [name, value] = cookie.split('=');
            if (name === 'accept') {
                return value; // 'yes'
            }
        }
        
        return null; // если cookie не найдена
      }
    }
  }
  </script>
  
  <style>
  
  </style>
  -->

  <template>
    <!-- 
      <v-bottom-sheet
        v-model="drawer"
        inset
        persistent
        class="cookie-sheet"
        hide-overlay
        no-click-animation
        :no-click-animation="true"
      >
        <v-card class="cookie-card">
          <v-card-text class="d-flex align-center flex-wrap ga-4 pa-4">
            <div class="cookie-text flex-grow-1">
              <p v-if="lang == 'en'" class="ma-0">
                This website uses cookies to give you the best possible user experience. 
                By continuing to use the website without changing your browser settings you agree to the use of cookies. 
                For further information on cookies, please read our 
                <a href="#" @click.prevent="$router.push('/Cookie')">cookie policy</a>.
              </p>
              <p v-if="lang == 'ru'" class="ma-0">
                Этот сайт использует файлы cookie, чтобы обеспечить вам максимально возможное удобство пользования. 
                Продолжая использовать сайт без изменения настроек браузера, вы соглашаетесь на использование файлов cookie. 
                Для получения дополнительной информации о файлах cookie, пожалуйста, ознакомьтесь с нашей 
                <a href="#" @click.prevent="$router.push('/Cookie')">политикой обработки cookies</a>.
              </p>
            </div>
            <v-btn 
              color="primary" 
              @click="acceptCookie()"
              class="flex-shrink-0"
            >
              <span v-if="lang == 'en'">Agree</span>
              <span v-if="lang == 'ru'">Согласие</span>
            </v-btn>
            <v-btn 
              color="primary" 
              @click="declineCookies()"
              class="flex-shrink-0"
            >
              <span v-if="lang == 'en'">Decline</span>
              <span v-if="lang == 'ru'">Отклонить </span>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-bottom-sheet>
      -->
    <v-snackbar
    v-model="drawer"
    location="bottom"
    :timeout="-1"
    :persistent="true"
    color="white"
    class="cookie-snackbar"
  >
    <div class="d-flex align-center flex-wrap ga-4">
      <div class="flex-grow-1">
        <p v-if="lang == 'en'" class="ma-0 text-body-2">
          This website uses cookies to give you the best possible user experience. 
          By continuing to use the website without changing your browser settings you agree to the use of cookies. 
          For further information on cookies, please read our
          <a href="#" @click.prevent="$router.push('/Cookie')">cookie policy</a>
        </p>
        <p v-if="lang == 'ru'" class="ma-0 text-body-2">
          Этот сайт использует файлы cookie, чтобы обеспечить вам максимально возможное удобство пользования. 
          Продолжая использовать сайт без изменения настроек браузера, вы соглашаетесь на использование файлов cookie. 
          Для получения дополнительной информации о файлах cookie, пожалуйста, ознакомьтесь с нашей  
          <a href="#" @click.prevent="$router.push('/Cookie')">политикой обработки cookies</a>
        </p>
      </div>
      <v-btn color="primary" @click="acceptCookie()" size="small">Agree</v-btn>
      <v-btn color="secondary" @click="declineCookies()" variant="text" size="small">Decline</v-btn>
    </div>
  </v-snackbar>
</template>

<script>
import { mapState } from "vuex";

export default {    
  name: "CookieBar",
  data() {
    return {
      drawer: false,
    }
  },
  created() {
    const acceptValue = this.getAcceptValue()
    if (acceptValue !== 'yes') {  
      this.drawer = true
    }
  },
  computed: {
    ...mapState(['lang']),
  },
  methods: {
    declineCookies() {
      // setCookie('cookie_consent', 'declined', 365);
      // document.getElementById('cookieBanner').style.display = 'none';
      window.location.href = 'about:blank';
    },
    acceptCookie() {
      // Устанавливаем cookie на 365 дней
      // const date = new Date();
      // date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
      document.cookie = `accept=yes;`;
      this.drawer = false
      console.log('Cookie accepted:', document.cookie);
    },
    getAcceptValue() {
      const cookies = document.cookie.split('; ');
      for (let cookie of cookies) {
        const [name, value] = cookie.split('=');
        if (name === 'accept') {
          return value;
        }
      }
      return null;
    }
  }
}
</script>

<style>
.cookie-sheet {
  z-index: 1000;
}

/* Этот стиль гарантированно уберёт любые следы overlay */
.cookie-sheet .v-overlay__scrim {
  background-color: transparent !important;
  opacity: 0 !important;
  display: none !important;
}

.cookie-card {
  border-radius: 12px 12px 0 0 !important;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1) !important;
}

.cookie-text {
  font-size: 14px;
  line-height: 1.5;
}

.cookie-text a {
  color: rgb(var(--v-theme-primary));
  text-decoration: none;
}

.cookie-text a:hover {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .cookie-card .v-card-text {
    flex-direction: column;
    text-align: center;
  }
  
  .cookie-text {
    width: 100%;
  }
  
  .cookie-btn {
    width: 100%;
  }
}
</style>